export default __webpack_public_path__ + "static/marketplace-fraud-prevention-img-1-90bcac353da727f59bd7ec00a5e66805.png";